import { render, staticRenderFns } from "./BankDetailsActivity.vue?vue&type=template&id=94edb1de&scoped=true&"
import script from "./BankDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./BankDetailsActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=94edb1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94edb1de",
  null
  
)

export default component.exports